export const version = {
    major: 1,
    minor: 6,
    patch: 107
}
